const getters = {
    paymentStatus: state => state.paymentStatus,
    paymentErrors: state => state.paymentErrors,
    payments: state => state.payments,
    paymentsCount: state => state.paymentsCount,
    paymentDetailById: (state) => (id) => {
    	return state.payments.find(payment => payment.p_id === id)
  	},
}

export default getters
